import { render, staticRenderFns } from "./DxProductWarehouse.vue?vue&type=template&id=74289870&"
import script from "./DxProductWarehouse.vue?vue&type=script&lang=js&"
export * from "./DxProductWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./DxProductWarehouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports